import React, { useState } from 'react';
import { Box, Card, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel'; import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Grid from '@mui/material/Grid2';
import WhiteTooltip from '../../../components/WhiteTooltip';

const AgentDetails = (agent: any) => ({
  description: agent?.description || 'No description provided.',
  linkedScans: agent?.linked_scans_count || 0,
  agentId: agent?.id || '-',
  otp: agent?.otp || '-',
  version: agent?.meta_data?.version || '-',
  dateInstalled: agent?.meta_data?.date_installed ? new Date(agent.meta_data.date_installed).toLocaleString() : '-',
  dateCreated: agent?.date_added ? new Date(agent.date_added).toLocaleString() : '-',
  hostName: agent?.meta_data?.hostname || '-',
  hostIp: agent?.meta_data?.host_ip || '-',
  macId: agent?.meta_data?.mac_id || '-',
  lastActivity: agent?.last_activity ? new Date(agent.last_activity).toLocaleString() : '-',
  lastModified: agent?.last_modified ? new Date(agent.last_modified).toLocaleString() : '-',
  agentType: agent?.agent_type ? (Array.isArray(agent.agent_type) ? agent.agent_type.join(', ') : agent.agent_type) : '-',
});

const getStatusStyles = (status: string) => {
  switch (status?.toLowerCase()) {
    case 'active':
      return { bgcolor: '#ECFDF5', color: '#22C55E', borderColor: '#22C55E' };
    case 'pending':
      return { bgcolor: '#FFF9E6', color: '#E5C205', borderColor: '#E5C205' };
    case 'inactive':
      return { bgcolor: '#FEF2F2', color: '#DC3545', borderColor: '#DC3545' };
    default:
      return { bgcolor: '#F8F9FA', color: '#6C757D', borderColor: '#6C757D' };
  }
};

const AgentDetailsOverlay: React.FC<any> = ({ selectedAgent, onClose, onOpenLinkedScans }) => {
  const d = AgentDetails(selectedAgent || {});
  console.log(selectedAgent, "seds");




  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text || '');
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 2000);
  };

  return (
    <Card variant="outlined" sx={{ height: '100%', borderRadius: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2.5, borderBottom: '1px solid #E2E2F2' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 18 }}>{selectedAgent?.name || 'Agent-Name'}</Typography>
          <Chip
            label={selectedAgent?.status_display || 'Active'}
            size="small"
            sx={{
              ...getStatusStyles(selectedAgent?.status_display),
              fontWeight: 600,
              border: '1px solid'
            }}
          />
        </Box>
        <IconButton size="small" onClick={() => onClose && onClose()}>
          <CancelIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: 3 }}>
        <Typography sx={{ color: '#696595', fontSize: "13px" }}>Description</Typography>

        <Typography sx={{ mb: 3, color: '#696595', fontSize: "13px", fontWeight: 700, }}>{d.description}</Typography>

        <Grid container spacing={4} rowSpacing={3}>
          {/* Row 1 */}
          <Grid size={4}>
            <Typography sx={{ fontSize: 13, color: '#8B8B9A', mb: 0.5 }}>Linked Scans</Typography>
            <Typography sx={{ cursor: 'pointer', color: '#3A2ADA', fontWeight: 500, fontSize: 13 }} onClick={() => onOpenLinkedScans && onOpenLinkedScans(selectedAgent)}>{d.linkedScans}</Typography>
          </Grid>

          {/* <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Agent ID</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 12,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  flexGrow: 1
                }}
              >
                {d.agentId}
              </Typography>
              <Tooltip title="Copy">
                <IconButton size="small" onClick={() => handleCopy(d.agentId)} sx={{ p: 0.5 }}>
                  <ContentCopyIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid> */}

          {/* <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>OTP</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>******</Typography>
          </Grid> */}

          {/* Row 2 */}
          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Version</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.version}</Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Date Installed</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.dateInstalled}</Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Date Created</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.dateCreated}</Typography>
          </Grid>

          {/* Row 3 */}
          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Host Name</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.hostName}</Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Host IP</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.hostIp}</Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>MAC ID</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.macId}</Typography>
          </Grid>

          {/* Row 4 */}
          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Last Activity</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.lastActivity}</Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Last Modified</Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 12 }}>{d.lastModified}</Typography>
          </Grid>
          {/* 
          <Grid size={4}>
            <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>Agent Type</Typography>
            <Typography sx={{ fontWeight: 500, textTransform: 'capitalize', fontSize: 12 }}>{d.agentType}</Typography>
          </Grid> */}

          {selectedAgent?.status_display === 'Unenrolled' && (
            <Grid size={12}>
              <Typography sx={{ fontSize: 12, color: '#8B8B9A', mb: 0.5 }}>
                Agent Uninstallation Command
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: 12,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    flexGrow: 1,
                  }}
                  title={selectedAgent?.spark_agent_uninstall_cmd || ''}
                >
                  {selectedAgent?.spark_agent_uninstall_cmd || '-'}
                </Typography>
                {!!selectedAgent?.spark_agent_uninstall_cmd && (
                  <WhiteTooltip title={copySuccess ? 'Copied!' : (selectedAgent?.spark_agent_uninstall_cmd || '')}
                    arrow placement="bottom">
                    <IconButton
                      size="small"
                      onClick={() => handleCopy(selectedAgent?.spark_agent_uninstall_cmd)}
                      sx={{ p: 0.5 }}
                    >
                      <ContentCopyIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </WhiteTooltip>
                )}
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, p: 2.5, borderTop: '1px solid #F1F1F5', mt: 'auto' }}> */}
      {/* <Button variant="outlined" sx={{ textTransform: 'none', px: 3, py: 1 }}>Edit</Button> */}
      {/* <Button variant="contained" color="primary" sx={{ textTransform: 'none', px: 3, py: 1 }} onClick={() => onClose && onClose()}>Close</Button> */}
      {/* </Box> */}
    </Card>
  );
};

export default AgentDetailsOverlay;
